export const ELEMENT_DATE_TODAY = 'date_today';
